/* eslint-disable */
export const TYPE_OPTIONS = [
  {
    value: 3,
    label: 'HIS应用'
  },
  {
    value: 1,
    label: '小程序应用'
  },
  {
    value: 2,
    label: 'Web应用'
  }
]

// 审批状态选项
export const APPROVAL_STATUS_OPTIONS = [
  {
    value: 1,
    label: '待审批'
  },
  {
    value: 2,
    label: '通过'
  },
  {
    value: 3,
    label: '拒绝'
  }
]

// 申请审批类型
export const APPLY_APPROVAL_TYPE = [
  {
    value: 1,
    label: '首次申请开通应用'
  },
  {
    value: 2,
    label: '到期续费'
  },
  {
    value: 3,
    label: '申请功能升级'
  },
  {
    value: 4,
    label: '续费和功能升级'
  }
]

export const applicationStatus = {
  [1]: '使用中',
  [2]: '停用',
  [3]: '申请中'
}

export const approvalStatus = {
  [1]: '待审批',
  [2]: '通过',
  [3]: '拒绝'
}

export const Type = {
  [1]: '加密狗审批',
  [2]: '平台应用审批'
}

export const ApplyType = {
  [1]: '首次申请开通应用',
  [2]: '到期续费',
  [3]: '申请功能升级',
  [4]: '续费和功能升级',
  // eslint-disable-next-line
  [5]: '其他'
}

export const rules = {
  value: [
    {
      required: true,
      message: '审批人不能为空'
    }
  ],
  level: [
    {
      required: true,
      message: '审批顺序节点不能为空'
    }
  ]
}

export const hisTableSchema = [
  {
    prop: 'moduleConfigName',
    label: '加密狗应用名称',
    minWidth: 80
  },
  {
    prop: 'clinicName',
    label: '门诊名称',
    minWidth: 80
  },
  {
    prop: 'tenantName',
    label: '租户名称',
    minWidth: 80
  },
  {
    prop: 'name',
    label: '加密狗客户编号',
    minWidth: 80
  },
  {
    prop: 'beginTime',
    label: '服务开始时间',
    minWidth: 80
  },
  {
    prop: 'endTime',
    label: '服务结束时间',
    minWidth: 80
  },
  {
    prop: 'approvalTime',
    label: '申请时间',
    minWidth: 60
  },
  {
    prop: 'applyStatus',
    label: '应用状态',
    minWidth: 80
  },
  {
    prop: 'applyUserNmae',
    label: '申请人',
    minWidth: 60
  },
  {
    prop: 'applyApprovalType',
    label: '申请类型',
    minWidth: 80
  },
  {
    prop: 'approvalStatus',
    label: '审核状态',
    minWidth: 60
  }
]

export const platTableSchema = [
  {
    prop: 'moduleConfigName',
    label: '应用类别名称',
    minWidth: 80
  },
  {
    prop: 'clinicName',
    label: '门诊名称',
    minWidth: 80
  },
  {
    prop: 'tenantName',
    label: '租户名称',
    minWidth: 80
  },
  {
    prop: 'beginTime',
    label: '服务开始时间',
    minWidth: 80
  },
  {
    prop: 'endTime',
    label: '服务结束时间',
    minWidth: 80
  },
  {
    prop: 'approvalTime',
    label: '申请时间',
    minWidth: 80
  },
  {
    prop: 'applyStatus',
    label: '应用状态',
    minWidth: 80
  },
  {
    prop: 'operName',
    label: '操作人',
    minWidth: 60
  },
  {
    prop: 'applyApprovalType',
    label: '申请类型',
    minWidth: 80
  },
  {
    prop: 'approvalStatus',
    label: '审核状态',
    minWidth: 80
  }
]
